import { emptyLink, LinkConfiguration } from "./linkConfiguration";

export interface FooterConfiguration {
    visibleInAuthApp: boolean;
    socialMediaVisible: boolean;
    text: string[];
    aboutUs: LinkConfiguration;
    ifaPanelVisible: boolean;
    drawdownCostComparerVisible: boolean;
    privacyPolicy: LinkConfiguration;
    cookiePolicy: LinkConfiguration;
    cookieSettings: LinkConfiguration;
    termsAndConditions: LinkConfiguration;
    contactUs: LinkConfiguration;
    logoVisible: boolean;
    copyrightVisible: boolean;
}

const disabledConfig: FooterConfiguration = {
    visibleInAuthApp: false,
    socialMediaVisible: false,
    text: [],
    aboutUs: emptyLink,
    ifaPanelVisible: false,
    drawdownCostComparerVisible: false,
    privacyPolicy: emptyLink,
    cookiePolicy: emptyLink,
    cookieSettings: emptyLink,
    termsAndConditions: emptyLink,
    contactUs: emptyLink,
    logoVisible: false,
    copyrightVisible: false
};

export { disabledConfig };
